<template>
    <b-button variant="primary" @click.stop="exportar()">
        <i class="fa fa-file-pdf-o mr-2"></i> Exportar
    </b-button>
</template>

<script>
import download from './../../shared/download'

export default {
	props: {
		dirfBeneficiarioId: {
			type: String,
			default: () => ''
		},

		beneficiario: {
			type: String,
			default: () => ''
		},

		anoCalendario: {
			type: String,
			default: () => ''
		},

		dirfsServicos: {
			type: Object,
			default: () => {}
		},

		fornecedorId: {
			type: String,
			default: () => null
		}
	},

	data() {
		return {}
	},

	methods: {
		exportar() {
			this.$store.dispatch('addRequest')
			this.dirfsServicos
				.obterRendimentos(this.dirfBeneficiarioId, this.fornecedorId)
				.then(response => {
					if (response) {
						if (response.type === 'application/json') {
							this.$toast.error(
								'Falha ao obter Rendimentos',
								'ERROR',
								this.$toastConfig.error
							)
						} else {
							download(
								response,
								`Rendimentos_${this.beneficiario}_${this.anoCalendario}.pdf`
							)
						}
					}
					this.$store.dispatch('removeRequest')
				})
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
